module.exports = __webpack_public_path__ + "static/media/768-products---5-image-1.1281d5f4.png";